import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2e19162"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "assess-card-wrapper",
  class: "tw-flex tw-gap-[20px] tw-max-w-[1361px] tw-flex-wrap"
}
const _hoisted_2 = {
  id: "assess-manager-completion-card",
  class: "tw-flex-1"
}
const _hoisted_3 = {
  id: "assess-manager-details-card",
  class: "tw-flex-1"
}
const _hoisted_4 = {
  id: "assess-manager-contributors-card",
  class: "tw-flex-1 tw-max-w-[calc(50%-10px)]"
}

import CompletionCard from "./completionCard.vue";
import ContributorsCard from "./contributorsCard.vue";
import DetailsCard from "./detailsCard.vue";
import CompletionCardSkeleton from "./../skeleton/completionCardSkeleton.vue";
import DetailsCardSkeleton from "./../skeleton/detailsCardSkeleton.vue";
import ContributorsCardSkeleton from "./../skeleton/contributorsCardSkeleton.vue";

import { computed, onMounted, ref, watch } from "vue";
import store from "@/store";
import { useRoute } from "vue-router";

// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentCardWrapper',
  props: {
  contributorsCard: {
    type: Number,
    default: 0,
  },
  detail: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;



const route = useRoute();
const isMounted = ref(false);
const queryValue = computed(() => Number(route.query.checklistId));

watch(
  () => queryValue.value,
  (newVal) => {
    if (newVal) {
      isMounted.value = false;
      setTimeout(() => {
        isMounted.value = true;
      }, 1000);
    }
  },
);

onMounted(() => {
  setTimeout(() => {
    isMounted.value = true;
  }, 1000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isMounted.value)
        ? (_openBlock(), _createBlock(CompletionCard, {
            key: 0,
            detail: __props.detail,
            class: _normalizeClass('tw-flex-1 tw-min-w-[290px]')
          }, null, 8, ["detail"]))
        : (_openBlock(), _createBlock(CompletionCardSkeleton, {
            key: 1,
            class: _normalizeClass('tw-flex-1 tw-max-w-none')
          }))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (isMounted.value)
        ? (_openBlock(), _createBlock(DetailsCard, {
            key: 0,
            class: _normalizeClass('tw-flex-1 tw-max-w-none')
          }))
        : (_openBlock(), _createBlock(DetailsCardSkeleton, {
            key: 1,
            class: _normalizeClass('tw-flex-1 tw-max-w-none')
          }))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (isMounted.value)
        ? (_openBlock(), _createBlock(ContributorsCard, {
            key: 0,
            class: _normalizeClass('tw-flex-1 tw-max-w-none'),
            "checklist-id": props.contributorsCard
          }, null, 8, ["checklist-id"]))
        : (_openBlock(), _createBlock(ContributorsCardSkeleton, {
            key: 1,
            class: _normalizeClass('tw-flex-1 tw-max-w-none')
          }))
    ])
  ]))
}
}

})